import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatDialog } from '@angular/material/dialog';

import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { SharedModule } from 'src/app/shared/shared.module';
import {
  EducationalData,
  OrderRequest
} from 'src/app/shared/model/order.model';
import { ModelStock } from 'src/app/shared/model/vehicle.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';

import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-didactic',
  templateUrl: './didactic.component.html',
  styleUrls: ['./didactic.component.scss'],
  imports: [CommonModule, I18NextModule, SharedModule, StepperComponent]
})
export class DidacticComponent implements OnInit, AfterViewInit {
  spinner = false;
  user!: User;

  steps = new Map<string, boolean>();

  requestFormInfo: any;
  requestFormError = false;
  requestObj!: OrderRequest;
  controller?: AuthorizerUsers;
  authorizer?: AuthorizerUsers;
  requestTypeEnum = RequestType;
  educationalData!: EducationalData;
  modelList!: ModelStock[];
  isLinear = true;
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    private vehiclesService: VehiclesService,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.setSteps();
    this.vehiclesService.getStockModels().subscribe({
      next: (resp: ModelStock[]) => {
        return (this.modelList = resp);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('approvers', true);
    this.steps.set('request-info', false);
    this.steps.set('car-config', true);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }

  generateRequestObject(newRequestData: any) {
    const orderInfo = {
      requestType: RequestType.didactic,
      comments: newRequestData.comments,
      controllerUserId: newRequestData.controller?.id,
      delegatedApproverUserId: newRequestData.authorizer?.id
    };

    const phone = newRequestData.extraPhone?.trim();
    const email = newRequestData.extraEmail?.trim();

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    const educationalData: EducationalData = {
      reason: newRequestData.reason,
      specifications: newRequestData.specifications,
      use: newRequestData.use,
      fuelType: newRequestData.propulsion,
      stockVehicle: { model: newRequestData.model }
    };

    this.requestObj = {
      orderInfo: { ...orderInfo },
      educationalData: { ...educationalData },
      contactInfoDataDTO: { ...contactInfoDataDTO }
    };
  }

  openConfirmationModal() {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.coreService.newOrder(this.requestObj).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.generateRequestObject(newRequestData);
    this.openConfirmationModal();
  }
}
